import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/Login'

import { auth } from '@/components/Firebase_Conn'
import { jStore } from '@/store/jestionaleStore.js'


const crudTableListino = () => import('@/components/crudTableListino')
const crudTableMagazzino = () => import('@/components/crudTableMagazzino')
const crudTableOrdini = () => import('@/components/crudTableOrdini')
const statistiche = () => import('@/components/statistiche')

Vue.use(Router)

let router = new Router({
  base: '/',
  mode: 'history', // Senza questa istruzione usciva un # nell'url
  routes: [
    {
      path: '*',
      redirect: '/ordini'
    },
    {
      path: '/',
      redirect: '/ordini'
    },
    {
      path: '/login',
      name: 'login',
      components: {
        loginView: login
      }
    },
    {
      path: '/ordini',
      name: 'Ordini',
      component: crudTableOrdini,
      // The URL /clienti?query=*** would pass {query: '***'} as props to the Client component.
      props: (route) => ({ query: route.query }),
      meta: { requiresAuth: 'False' }
    },
    {
      path: '/ordini-scheletro',
      name: 'OrdiniScheletro',
      component: crudTableOrdini,
      // The URL /clienti?query=*** would pass {query: '***'} as props to the Client component.
      props: (route) => ({ query: route.query }),
      meta: { requiresAuth: 'False' }
    },
    {
      path: '/ordine_old',
      name: 'Ordine',
      component: crudTableOrdini,
      // The URL /clienti?query=*** would pass {query: '***'} as props to the Client component.
      props: (route) => ({ query: route.query }),
      meta: { requiresAuth: 'False' }
    },
    {
      path: '/magazzino',
      name: 'Magazzino',
      component: crudTableMagazzino,
      // The URL /clienti?query=*** would pass {query: '***'} as props to the Client component.
      props: (route) => ({ query: route.query }),
      meta: { requiresAuth: 'False' }
    },
    {
      path: '/listini',
      name: 'Listini',
      component: crudTableListino,
      // The URL /clienti?query=*** would pass {query: '***'} as props to the Client component.
      props: (route) => ({ query: route.query }),
      meta: { requiresAuth: 'False' }
    },
    {
      path: '/statistiche',
      name: 'Statistiche',
      component: statistiche,
      // The URL /clienti?query=*** would pass {query: '***'} as props to the Client component.
      props: (route) => ({ query: route.query }),
      meta: { requiresAuth: 'False' }
    }
  ]
})

// CONTROLLO AD OGNI ROUTING SE LA PAGINA RICHIEDE IL LOGIN E SE SONO LOGGATO
router.beforeEach((to, from, next) => {
  auth.onAuthStateChanged((user) => {
    // console.log(auth.currentUser)
    if (auth.currentUser) {
      jStore.commit('loginStates/setLoggedState', true)
      jStore.commit('loginStates/setUserDettails', auth.currentUser)
      if (to.path === '/') {
        router.push('/ordini')
      }
      next()
    } else {
      jStore.commit('loginStates/setLoggedState', false)
      console.log('There is no token, redirect to login. (' + to.path + ')')
      if (to.path !== '/login') {
        router.push('/login')
      }
      next()
    }
  })
})

export default router